import * as types from "../action-types.js";
import _ from "lodash";
import { items } from "@/components/Sider/Sider";
import { toPermissions } from "@/App";

import { DetectionTypeDict } from "@/types/common";
import formatMessageSelf from "@/i18n/formatMessageSelf";
import { formatMenuItem } from "@/i18n/formatMessageStatusOptions";
import { isTargetPersons } from "@/utils/common";

type Permissions = {
	[key: string]: number[];
};
type User = {
	user_id: string;
	user_name: string;
	is_admin: boolean;
};
const initState: {
	permissions: Permissions;
	user: undefined | User | null; //初始（进行中）、成功、失败
	menuItems?: any[];
	configsPermissions?: any;
	configsDisplay?: any;
	locale?: string;
} = {
	permissions: {},
	user: undefined,
	configsPermissions: null,
	configsDisplay: null,
	locale: "zh-CN",
};

const getMenusByPermissions = (
	rawPermissions = {},
	user,
	locale,
	configsDisplay
) => {
	const { target_persons } = configsDisplay;
	// 处理item多语言
	const fm = formatMessageSelf(locale || "zh-CN");
	const newItems = formatMenuItem(fm, items);
	const rawMenuItems = _.cloneDeep(newItems);
	// rawPermissions内容检测的菜单权限：[deepfake, diffusion, diffusion_full_frame, llm, admin || _normal]
	const permissions = [
		...toPermissions(rawPermissions),
		user?.is_admin ? "admin" : "_normal",
	];
	const filterCb = (item) =>
		item.access ? permissions.includes(item.access) : true;

	const menuItems = rawMenuItems.filter(filterCb).map((item) => {
		if (item.children) {
			// 过滤admin、以及后台返回的权限
			item.children = item.children.filter(filterCb);
			// 增加对特定人的过滤
			// 处理特定人 target_persons为1且权限为admin才会显示该模块，非admin本身就无法显示该模块
			!!item.key &&
				item.key === "config" &&
				!isTargetPersons(target_persons) &&
				(item.children = []);
		}
		return item;
	});

	return menuItems.filter((item) => !item.children || item.children.length);
};

export default (state = initState, { type, data }) => {
	switch (type) {
		case types.PERMISSIONS:
			return {
				...state,
				permissions: data,
				menuItems: getMenusByPermissions(
					data,
					state.user,
					state.locale,
					state.configsDisplay
				),
			};
		case types.USER_SUCCESS:
			return {
				...state,
				user: data,
				menuItems: getMenusByPermissions(
					state.permissions,
					data,
					state.locale,
					state.configsDisplay
				),
			};
		case types.USER_FAIL:
			return {
				...state,
				user: null,
			};
		case types.CONFIGURABLE_DATA: {
			const { permissions, display, locale } = data;
			const newPermissions = {};
			Object.keys(permissions).forEach((item: string) => {
				if (permissions[item] && permissions[item].length) {
					newPermissions[item] = permissions[item];
				}
			});

			const menuName = {};
			Object.keys(display.menu_name).forEach((item) => {
				menuName[item] = {
					...DetectionTypeDict[item],
					label: display.menu_name[item],
					defaultText: display.menu_name[item],
				};
			});

			return {
				...state,
				configsPermissions: newPermissions,
				configsDisplay: {
					...display,
					menu_name: menuName,
				},
				locale,
			};
		}
		default:
			return state;
	}
};
